export default {
  period: {
    hours24: 'За 24 часа',
    day: 'За сегодня',
    yesterday: 'За вчера',
    week: 'За неделю',
    month: 'За месяц',
    anytime: 'За все время',
    range: 'Произвольно',
  },
};
